export const splitPublishedCaptions = (captions?: string) => {
  if (captions === undefined) {
    return [];
  }

  return captions.replace(/\+\n/g, '').split(/\n/g);
};

export default splitPublishedCaptions;
